module.exports = __webpack_public_path__ + "media/images/quickbooks-9994500655c4ea037aefd35271a9cfdc.svg";